import { usePartialUpdateCompetitionRegistrationMutation } from '../mutations';
import { RegisterLifterForm } from '../components/register-lifter-form';
import { idParamSchema, registrationIdParamSchema } from '~/schemas';
import { Schema } from '../components/register-lifter-form-schema';
import { useCompetitionRegistrationDetailQuery } from '../queries';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useCompetitionQuery } from '../../../queries';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const { id: competitionId } = useParams(idParamSchema.parse);
  const { registrationId } = useParams(registrationIdParamSchema.parse);

  const { data: competition } = useCompetitionQuery(competitionId);
  const { data: registration } = useCompetitionRegistrationDetailQuery(registrationId);
  const mutation = usePartialUpdateCompetitionRegistrationMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(
      mutation.mutateAsync({
        id: registrationId,
        payload: {
          competition_type: payload.competition_type_id ?? undefined,
          weight_class: payload.weight_class_id,
          age_category: payload.category_id,
          team: payload.team_id,
          is_reserve: payload.is_reserve,
        },
      }),
      {
        success: 'Anmälan har uppdaterats',
        pending: 'Uppdaterar anmälan...',
      }
    );
    navigate(`/competitions/${competitionId}/registrations/manage`);
  }

  if (!registration) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera anmälan" />

      <PageLayout.Section>
        <RegisterLifterForm
          key={registrationId}
          mode="edit"
          competitionId={competitionId}
          isTeamComp={competition?.is_team_comp ?? false}
          defaultValues={{
            person_id: registration.person.id,
            competition_type_id: registration.competition_type ? String(registration.competition_type.id) : '',
            category_id: registration.age_category ? String(registration.age_category.id) : '',
            weight_class_id: registration.weight_class ? String(registration.weight_class.id) : '',
            team_id: registration.team?.id ?? null,
            is_reserve: registration.is_reserve ?? false,
          }}
          personName={`${registration.person.first_name} ${registration.person.last_name}`}
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
